import { render, staticRenderFns } from "./CreateAssetWidget.vue?vue&type=template&id=c03acc80&"
import script from "./CreateAssetWidget.vue?vue&type=script&lang=js&"
export * from "./CreateAssetWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports